import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { APIProcessor } from '../processor/apiProcessor';
import { BaseContext } from '../../utils/basecontext';
import { HttpClient } from '../../utils/httpclient/httpclient';

export interface ProcessorFactory<T extends APIRequest, R extends APIResponse>
{
    create(): APIProcessor<T, R>;
    update(): APIProcessor<T, R>;
    delete(): APIProcessor<T, R>;
    load(): APIProcessor<T, R>;
    copy(): APIProcessor<T, R>; 
}

export class ProcessorFactoryImpl<T extends APIRequest, R extends APIResponse> implements ProcessorFactory<T, R>
{
    constructor(private applicationContext: BaseContext, private httpClient: HttpClient)
    {

    }

    protected getContext(): BaseContext
    {
        return this.applicationContext;
    }

    protected getHttpClient(): HttpClient
    {
        return this.httpClient;
    }
    
    create(): APIProcessor<T, R> {
        throw new Error("Method not implemented.");
    }    
    update(): APIProcessor<T, R> {
        throw new Error("Method not implemented.");
    }
    delete(): APIProcessor<T, R> {
        throw new Error("Method not implemented.");
    }
    copy(): APIProcessor<T, R> {
        throw new Error("Method not implemented.");
    }
    load(): APIProcessor<T, R> {
        throw new Error("Method not implemented.");
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/processorfactory.tsx